import StepLayout from './StepLayout.vue'

export default StepLayout
